import { Box, Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { useGeotoken } from '../../Contexts'

const FhrNote: React.FC = () => {
  const geotoken = useGeotoken()
  const isFhr = geotoken?.quadkey?.zoom() === 0
  if (isFhr) {
    return (
      <Box alignItems="center" display="flex" flexDirection="column">
        <Typography variant="body1">
          The FHR Geotoken is the root geotoken that contains the entire world. The first four geotokens are children of this token.
        </Typography>
        <Typography variant="body1">
          It is called FHR since it is owned by the{' '}
          <Link href="https://xyo.network" target="_blank">
            Founding Hodler Registry
          </Link>
          .
        </Typography>
        <Typography>
          As noted in the{' '}
          <Link component={RouterLink} to="/rules">
            rules
          </Link>
          , all assets that are collected in this token will be distributed to the FHR members.
        </Typography>
      </Box>
    )
  } else {
    return null
  }
}

export default FhrNote
